import { styled } from '@mui/system'
import { Box } from '@mui/material'

export const Wrapper = styled(Box)(props => `
    display: ${(props?.animate && !props?.theme?.animate) ? 'none' : 'flex'};
    z-index: 10;
`)
